var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('advanced-table',{attrs:{"headers":_vm.headers,"filters":_vm.filters,"sortBy":'startDate',"descending":true,"resource":_vm.resource,"optionLists":_vm.optionLists}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-65eb6ea2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/reports/Duties.vue
// module id = 1066
// module chunks = 1